import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Builder } from 'builder-pattern';
import { OneToNVerify } from './classes/one-to-n-enroll';
import { LibConfig, LibConfigService } from './verify.module';

@Injectable({
  providedIn: 'root',
})
export class EnrollService {
  constructor(
    @Inject(LibConfigService) private config: LibConfig,
    private http: HttpClient
  ) {}

  public oneToNVerify(
    request: any,
    accessToken: string
  ): Observable<OneToNVerify> {
    let headers;
    if (accessToken) {
      headers = new HttpHeaders()
        .set('authorization', `Bearer ${accessToken}`)
        .append('auth', `Bearer ${accessToken}`);
    }
    return this.http
      .post(
        `${
          this.config.apiUrl
            ? this.config.apiUrl
            : 'https://dev-facade-1ton-http-635t26xtnq-uc.a.run.app/api/v1/one2n/verify/'
        }`,
        request,
        {
          headers: headers,
        }
      )
      .pipe(
        map((response: any) =>
          Builder(OneToNVerify)
            .id(response.eventId)
            .user(response.user)
            .processingTime(response.processTime)
            .build()
        )
      );
  }
}
